'use client'

import { storyblokEditable } from '@storyblok/react/rsc'
import { type FC } from 'react'

import { Button } from 'base-ui'

import { type StoryblokComponentProps } from '../../model'
import { type StoryblokButtonV2Type } from '../../storyblok'
import { useStoryblokWebOrAppLink } from '../../useStoryblokLink'
import { StoryblokUnmappedIcon } from '../StoryblokIcon/StoryblokUnmapedIcon'

export const StoryblokButtonV2: FC<
  StoryblokComponentProps<StoryblokButtonV2Type>
> = ({ blok }) => {
  const { appHref, endIcon, href, startIcon, text, ...restProps } = blok

  const { target, url } = useStoryblokWebOrAppLink({
    appLink: appHref,
    link: href,
  })

  if (text === '' || !url) {
    return null
  }

  return (
    <Button<'a'>
      {...storyblokEditable(blok)}
      endIcon={endIcon ? <StoryblokUnmappedIcon icon={endIcon} /> : null}
      href={url}
      rel={target === '_blank' ? 'noreferrer' : undefined}
      slots={{ root: 'a' }}
      startIcon={startIcon ? <StoryblokUnmappedIcon icon={startIcon} /> : null}
      target={target}
      {...restProps}
    >
      {text}
    </Button>
  )
}
